// extracted by mini-css-extract-plugin
export var emptyListInfo = "list-module--empty-list-info--f29b4";
export var list = "list-module--list--7fd8a";